import { Mountains, Lightning, PersonSimpleRun, Bicycle, PersonSimpleSwim, ForkKnife, Barbell } from "@phosphor-icons/react";

// Mapeo central de focus -> icono + etiqueta legible
// Mantener llaves en minúscula sin tildes para coincidir con valores guardados en BD.
const META = {
  trail:    { Icon: Mountains,        label: "Trail" },
  montana:  { Icon: Mountains,        label: "Montaña" },
  ultra:    { Icon: Lightning,        label: "Ultra" },
  running:  { Icon: PersonSimpleRun,  label: "Running" },
  triatlon: { Icon: Bicycle,          label: "Triatlón" },
  ciclismo: { Icon: Bicycle,          label: "Ciclismo" },
  natacion: { Icon: PersonSimpleSwim, label: "Natación" },
  nutricion:{ Icon: ForkKnife,        label: "Nutrición" },
};

export function getFocusMeta(focus) {
  if (!focus) return { Icon: Barbell, label: "—" };
  const key = String(focus).toLowerCase().trim();
  return META[key] || { Icon: Barbell, label: focus };
}
